import { NgModule } from '@angular/core'
import { CheckoutB2BModule } from '@spartacus/checkout/b2b'
import { checkoutB2BTranslationChunksConfig, checkoutB2BTranslationsEn } from '@spartacus/checkout/b2b/assets'
import { CheckoutB2BRootModule } from '@spartacus/checkout/b2b/root'
import { CheckoutModule } from '@spartacus/checkout/base'
import { checkoutTranslationChunksConfig, checkoutTranslationsEn } from '@spartacus/checkout/base/assets'
import { CheckoutRootModule } from '@spartacus/checkout/base/root'
import { I18nConfig, provideConfig } from '@spartacus/core'
import { CustomCheckoutModule } from '../../../features/checkout/custom-checkout.module'

@NgModule({
  declarations: [],
  imports: [CheckoutRootModule, CheckoutB2BRootModule, CheckoutModule, CheckoutB2BModule, CustomCheckoutModule],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: checkoutTranslationsEn },
        chunks: checkoutTranslationChunksConfig
      }
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: checkoutB2BTranslationsEn },
        chunks: checkoutB2BTranslationChunksConfig
      }
    })
  ]
})
export class CheckoutFeatureModule {}
